// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  // Add your Firebase configuration here
  apiKey: "AIzaSyCyKB7K4hsM14Kww2MrSuGWDViNovqfIGc",

  authDomain: "veter-247b9.firebaseapp.com",

  projectId: "veter-247b9",

  storageBucket: "veter-247b9.firebasestorage.app",

  messagingSenderId: "814507832982",

  appId: "1:814507832982:web:646a18e40f9ef06c4df4b7",

  measurementId: "G-9YHES6FBJN"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);